import styled from 'styled-components';
import { breakpoints, colors } from '@style-guide/config';

const DirectoryProfileHeaderContainer = styled.div`
  background-color: ${colors.lightGray};
  min-height: 190px;
  padding: 20px;
  width: 100%;

  > svg {
    display: block;
  }

  @media (min-width: ${breakpoints.m}) {
    padding: 20px 35px 140px;
  }
`;

DirectoryProfileHeaderContainer.displayName = 'DirectoryProfileHeaderContainer';

export default DirectoryProfileHeaderContainer;
